<template>
  <div class="cg-main-wrapper" ref="cardWrapper">
    <div style="position: inherit; right: 10px; top: 35%">
      <v-btn
          x-large
          icon
          @click="hide"
      >
        <v-icon>
          mdi-close-circle
        </v-icon>
      </v-btn>
    </div>
    <div class="button-hide" >
      <button class="lookAll" @click="changeAllMarks">
                    <span class="pointer" v-if="!showAllMarks">
                Показать все
            </span>
        <span class="pointer" v-else>
                    Скрыть непопулярные
                </span>
      </button>

    </div>
    <h5 class="modal-title p-4 d-inline-block">
      Выберите марку и модель автомобиля: {{ chosenMark }} {{ chosenModel }}
    </h5>
    <template v-if="chosenMark">
      <button class="btn btn-success btn-sm" @click.prevent="clearMark">Выбрать другую</button>
    </template>
    <div class="cg-flex-wrpper">
      <template v-for="(item, index) in items">
        <div
            :data-test-id="'input' + (chosenMark ? 'Mark-' : 'Model-') + index"
            :key="'car-marks-1-' + index"
            class="inner-card"
            :class="highlightCard===index?'highlight':''"
            @click="chooseItem(index)"
        >
          <template v-if="item.carMarkModel">
            <span class="font-size-14">{{item.name}}</span>
          </template>
          <template v-else-if="chosenMark">
            <span class="font-size-14">{{item.name}}</span>
          </template>
          <template v-else>
            <v-img
                v-if="item.icon && item.icon.length > 0"
                :src="'data:image/svg+xml;base64,'+item.icon"
                height="25"
                width="75"
                max-width="80"
                contain
                style="margin-left:auto;margin-top:auto;margin-bottom: auto;margin-right: 5px;"
            />
            <div
                class="font-size-14"
                :style="item.image?'margin-left:0px;margin-top:auto;margin-bottom:auto;margin-right:auto;':'margin:auto'"
            >
              {{item.name}}
            </div>
          </template>
        </div>

        <!--                <div :key="'car-marks-' + index" v-if="maxRow(index)" clcontainer fill-height container--fluidass="break"></div>-->
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cars-models-grid',
  props: [ 'value', 'items', 'chosenMark', 'chosenModel', 'showAllMarks'],
  data() {
    return {
      show: true,
      wrapperWight: null,
      wrapperHeight: null,
      cardWight: 220,
      cardHeight: 50,
      highlightCard: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.wrapperWight = window.innerWidth
      this.wrapperHeight = window.innerHeight
      window.addEventListener('resize', this.onResize)
      window.addEventListener('keydown', this.keyHandle)
    })
  },
  computed: {
    itemsInRow() {
      return Math.floor(this.wrapperWight / this.cardWight)
    },
    rowInView() {
      return Math.floor( (this.wrapperHeight - 178) / this.cardHeight)
    },
    selRow() {
      return Math.floor(this.highlightCard/this.itemsInRow)
    },
  },
  watch: {
    items() {
      this.highlightCard = 0
      this.$refs.cardWrapper.scrollTop = 0
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('keydown', this.keyHandle)
  },
  methods: {
    clearMark() {
      this.$emit('clearMark')
    },
    hide() {
      this.$emit('hide', false)
    },
    changeAllMarks() {
      this.$emit('changeAllMarks', !this.showAllMarks)
    },
    keyHandle(key) {
      switch (key.code) {
        case('ArrowUp'):
          key.preventDefault()
          this.$refs.cardWrapper.scrollTop = (this.selRow * this.cardHeight) - this.cardHeight
          if (this.highlightCard >= this.itemsInRow) this.highlightCard = this.highlightCard - this.itemsInRow
          break
        case('ArrowLeft'):
          key.preventDefault()
          if ((this.highlightCard+1)%this.itemsInRow!==1) this.highlightCard--
          break
        case('ArrowRight'):
          key.preventDefault()
          if ((this.highlightCard+1)%this.itemsInRow!==0 && this.highlightCard+1 !== this.items.length) this.highlightCard++
          break
        case('ArrowDown'):
          key.preventDefault()
          this.$refs.cardWrapper.scrollTop = this.selRow * 60
          if((this.highlightCard+this.itemsInRow) < this.items.length) this.highlightCard = this.highlightCard + this.itemsInRow
          break
        case('Enter'):
          console.log('Enter')
          this.chooseItem(this.highlightCard)
          break
        default:
          console.log('keypress', key.code)
      }
    },
    onResize() {
      this.wrapperWight = window.innerWidth
    },
    maxRow(index) {
      return (index + 1)%this.itemsInRow === 0
    },
    chooseItem(val) {
      this.$emit('chooseItem', this.items[val])
    }
  }
}
</script>

<style scoped>
.lookAll {
  margin-left: auto;
  display: block;
  border: 1px solid #805b5b;
  border-radius: 9px;
  font-size: small;
  color: dimgrey;
  padding: 2px 5px;
}
.inner-card.highlight {
  box-shadow: 5px 5px #84c931;
}
.inner-card:hover {
  box-shadow: 5px 5px #c99631;
}
.inner-card {
  display: flex;
  width: 185px;
  box-shadow: 1px 1px #0c5460;
  padding: 10px;
  margin: 15px;
  border-radius: 0;
  background-color: white;
  border: 1px #acadac solid;
  vertical-align: center;

}
.cg-flex-wrpper {
  display: flex;
  flex-wrap: wrap;
}
.cg-main-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  margin: 0;
  height: 60%;
  background-color: rgb(201, 201, 199);
  z-index: 1200;
  padding: 25px;
  overflow-y: auto;
}
/*.break {*/
/*    flex-basis: 100%;*/
/*    height: 2px;*/
/*    background-color: #0b2e13;*/
/*}*/
</style>
